<template>
    <div class="tw:bg-[linear-gradient(180deg,rgba(15,23,42,0.05),rgba(255,255,255,0)_28%)]">
        <PageTitle :title="$t('perfil.cesion_estado_titulo')" />
        <section class="tw:mx-auto tw:w-full tw:max-w-5xl tw:px-4 tw:py-8 sm:tw:px-6 lg:tw:px-8">
            <div class="tw:space-y-6">
                <div class="tw:flex tw:justify-start sm:tw:justify-end">
                    <Button
                        variant="default"
                        custom-class="tw:rounded-full tw:border tw:border-slate-200 tw:bg-white tw:text-slate-700 hover:tw:bg-slate-50 sm:tw:w-auto"
                        icon-name="west"
                        icon-name-class="tw:text-base"
                        @click="goBack"
                    >
                        {{ $t('perfil.asiento_liberado_atras') }}
                    </Button>
                </div>

                <div class="tw:overflow-hidden tw:rounded-[32px] tw:border tw:border-slate-200 tw:bg-white tw:p-5 tw:shadow-[0_26px_70px_-42px_rgba(15,23,42,0.45)] sm:tw:p-6">
                    <p class="tw:text-xs tw:font-black tw:uppercase tw:tracking-[0.36em] tw:text-slate-400">
                        {{ $t('perfil.cesion_estado_titulo') }}
                    </p>
                    <h1 class="tw:mt-3 tw:text-2xl tw:font-black tw:text-slate-950 sm:tw:text-3xl">
                        {{ $t('perfil.cesion_detalle_header') }}
                    </h1>
                    <p class="tw:mt-4 tw:max-w-2xl tw:text-sm tw:text-slate-500">
                        {{ $t('perfil.cesion_detalle_instruccion') }}
                    </p>
                </div>

                <EventDetail
                    :evento="eventoInfo"
                    :estado="estadoActual"
                    :loading="loadingEstado || loadingEvento"
                    :error="errorEstado || errorEvento"
                    :loading-operacion="loadingOperacion"
                    :error-operacion="errorOperacion"
                    @ceder="handleCeder"
                    @recuperar="handleRecuperar"
                />
            </div>
        </section>
    </div>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import EventDetail from '@/modules/front/perfil/components/cesion/EventDetail.vue';
    import Button from '@/modules/front/ui/Button.vue';
    import { useCesionAsiento } from '@/composables/front/perfil/useCesionAsiento';
    import { useRoute } from '@/composables/common/router/useRouter';
    import router from '@/router';

    const $route = useRoute();

    const abonadoIdRef = ref($route.params.abono_id);

    const {
        eventoInfo,
        loadingEvento,
        errorEvento,
        estadoActual,
        loadingEstado,
        errorEstado,
        loadingOperacion,
        errorOperacion,
        selectEvento,
        ceder,
        recuperar,
    } = useCesionAsiento(abonadoIdRef);

    const handleCeder = async payload => {
        await ceder(payload);
    };

    const handleRecuperar = async() => {
        await recuperar();
    };

    const goBack = () => {
        router.back();
    };

    onMounted(() => {
        selectEvento($route.params.evento_id, $route.params.sesion_id);
    });
</script>
